class ProductTaxModel {
    shippingPrice!: number;
    salesTax!: number;
    shippingTax!: number;
    total!: number
  }
  
  export default ProductTaxModel;